import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "discuss-index"
};
import TopBar from './TopBar';
import Notice from './Panels/Notice/index';
import Resource from './Panels/Resource';
import File from './Panels/File';
import Course from './Panels/Course/index';
import Curriculum from './Panels/Curriculum/index';
import Meeting from './Panels/Meeting';
import Board from './Panels/Board';
import Result from './Panels/Result';

/* 工具 */
import { getDiscussBasic } from '@/api/index-bei-discuss';

/* api */
import { ref, markRaw, computed, onMounted, provide, inject } from 'vue';

/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 组件 */
    var discussId = inject('discussId');
    var componentMap = {
      1: markRaw(Notice),
      2: markRaw(Resource),
      3: markRaw(File),
      4: markRaw(Course),
      5: markRaw(Curriculum),
      6: markRaw(Meeting),
      7: markRaw(Board),
      8: markRaw(Result)
    };
    var tabId = ref(1);
    var discussInfo = ref({});
    provide('discussInfo', discussInfo);

    /* 计算属性 */
    var componentName = computed(function () {
      return componentMap[tabId.value];
    });

    /* 事件 */
    var tabChange = function tabChange(id) {
      tabId.value = id;
    };
    var getBaseInfo = function getBaseInfo() {
      if (discussId.value) {
        getDiscussBasic(discussId.value).then(function (res) {
          var _res$data;
          if ((res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 0) {
            discussInfo.value = res.data.data;
          }
        });
      }
    };

    /* 钩子 */
    onMounted(function () {
      getBaseInfo();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(TopBar), {
        onChange: tabChange
      }), (_openBlock(), _createBlock(_resolveDynamicComponent(componentName.value), {
        class: "bottom"
      }))]);
    };
  }
};